import { render, staticRenderFns } from "./goodsForecast.vue?vue&type=template&id=e2f94fa4&scoped=true"
import script from "./goodsForecast.vue?vue&type=script&lang=js"
export * from "./goodsForecast.vue?vue&type=script&lang=js"
import style0 from "./goodsForecast.vue?vue&type=style&index=0&id=e2f94fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f94fa4",
  null
  
)

export default component.exports